import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full max-w-3xl lg:max-w-4xl mx-auto" }
const _hoisted_2 = { class: "flex-1 border-r border-l ml-20 md:ml-64 min-h-screen" }
const _hoisted_3 = { class: "flex space-x-6 items-center justify-between px-8 py-4 border-b" }
const _hoisted_4 = ["textContent"]

import { useRoute } from 'vue-router'
import TheSidebar from './components/TheSidebar.vue'
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets'
import { initWallet } from 'solana-wallets-vue'
import { initWorkspace } from '@/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()

const wallets = [
    new PhantomWalletAdapter(),
    new SolflareWalletAdapter(),
]

initWallet({ wallets, autoConnect: true })
initWorkspace()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TheSidebar, { class: "py-4 md:py-8 md:pl-4 md:pr-8 fixed w-20 md:w-64" }),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", {
          class: "text-xl font-bold",
          textContent: _toDisplayString(_unref(route).name)
        }, null, 8, _hoisted_4)
      ]),
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})